import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, input, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router'; // Import Router
import { NbSidebarState } from '@nebular/theme/components/sidebar/sidebar.component';
import { ResponsiveMode } from '../../models/responsive-mode.type';
import { SideBarMenu } from '../../models/side-bar-menu.model';
import { UserModel } from '../../models/user.model';
import { Workspace } from '../../models/work-space.model';

@Component({
  selector: 'tart-compacted-side-bar-menu',
  templateUrl: './compacted-side-bar-menu.component.html',
  styleUrls: ['./compacted-side-bar-menu.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CompactedSideBarMenuComponent implements OnChanges {
  @Input() user: UserModel;
  @Input() selectedWorkspace: Partial<Workspace>;
  @Input() responsiveMode: ResponsiveMode;
  @Input() activeLink: string;
  @Input() activeTabId: string; 
  @Output() expandMenuEvent = new EventEmitter<NbSidebarState>();
  @Output() routeChange = new EventEmitter<string>();

  topSideBarMenu: Partial<SideBarMenu>[] = [];
  bottomSideBarMenu: Partial<SideBarMenu>[] = [];
  subSideBarAllContentMenu: Partial<SideBarMenu>[] = [];
  subSideBarBookmarkedMenu: Partial<SideBarMenu>[] = [];
  currentHoveredMenu: string = '';
  hoveringSubMenu: boolean = false;
  currentHoveredItems: Partial<SideBarMenu>[] = [];

  constructor(private router: Router, private cdr: ChangeDetectorRef,) {} 
  ngOnChanges(changes: SimpleChanges): void {
    if ((changes['selectedWorkspace'] || changes['user'] || changes['responsiveMode']) && this.user && this.selectedWorkspace) {
      this.setSideBarValues(this.selectedWorkspace.workspaceId);
    }
    if (changes['activeLink'] || changes['activeTabId']) {
      this.cdr.detectChanges(); 
    }
  }

  expandMenu(): void {
    this.expandMenuEvent.emit('expanded');
  }

  changeRoute(link: string): void {
    this.routeChange.emit(link);
    this.activeLink = link; 
    this.activeTabId = 'DashboardGroup'
    this.cdr.detectChanges(); 
 }

 changeRouteWithTab(link: string, tabId: string): void {
    this.routeChange.emit(link);
    this.activeTabId = tabId;
    this.activeLink = link;
    this.router.navigate([link], { queryParams: { selectedTab: tabId } });
    this.cdr.detectChanges(); 
 }

 onHoverIcon(icon: string): void {
  if (icon === 'folder') {
  this.hoveringSubMenu = true;
  this.currentHoveredMenu = 'allContent';
    this.currentHoveredItems = this.subSideBarAllContentMenu;
  } else if (icon === 'bookmark') {
    this.hoveringSubMenu = true;
    this.currentHoveredMenu = 'bookmarked';
    this.currentHoveredItems = this.subSideBarBookmarkedMenu;
  }
}

onSubMenuEnter(): void {
  this.hoveringSubMenu = true;
}

onLeaveIcon(): void {
  this.hoveringSubMenu = false;
  this.currentHoveredItems = [];
}

onCheckLeave(event: MouseEvent): void {
  const target = event.target as HTMLElement;
  const safeSelectors = ['morva-icons', 'submenu-content', 'submenu-item', 'submenu-arrow'];
  if (!safeSelectors.some((selector) => target.closest(selector))) {
    this.onLeaveIcon();
  }
}

  private setSideBarValues(workspaceId: string): void {
    this.topSideBarMenu = [
      {
        icon: 'home',
        link: `/home/${workspaceId}`,
        havingAccess: true,
      },
      {
        icon: 'folder',
        link: `/home/explore/${workspaceId}`,
        havingAccess: true,
      },
      {
        icon: 'bookmark',
        link: `/home/bookmarked/${workspaceId}`,
        havingAccess: true,
      },
      {
        icon: 'branches',
        link: `/dataModelling/${workspaceId}`,
        havingAccess:
          this.selectedWorkspace.permissions.get('ViewDataSourceRelation').isChecked &&
          (this.responsiveMode === 'lg' || this.responsiveMode === 'xl'),
      },
      {
        icon: 'userManagement',
        link: `/home/user-managment/${workspaceId}`,
        havingAccess:
          (this.user.isSuperAdmin ||
            this.selectedWorkspace.permissions.get('UserManagement').isChecked) &&
          (this.responsiveMode === 'lg' || this.responsiveMode === 'xl'),
      },
    ];

    this.bottomSideBarMenu = [
      {
        icon: 'settings',
        link: `/home/setting/${workspaceId}`,
        havingAccess:
          this.user.isSuperAdmin && (this.responsiveMode === 'lg' || this.responsiveMode === 'xl'),
      },
      {
        icon: 'workspace',
        link: '/select-workspace',
        havingAccess: true,
      },
    ];

    this.subSideBarAllContentMenu = [
      {
        title: 'گروه داشبوردی',
        translateKey: 'NavigationSidebar.DASHBOARDGROUP',
        icon: 'dashboardGroup',
        link: `/home/explore/${workspaceId}`,
        tabId: 'DashboardGroup',
        havingAccess: true,
      },
      {
        title: 'داشبورد',
        translateKey: 'NavigationSidebar.DASHBOARD',
        icon: 'dashboard',
        link: `/home/explore/${workspaceId}`,
        tabId: 'Dashboard',
        havingAccess: true,
      },
      {
        title: 'منبع داده',
        translateKey: 'NavigationSidebar.DATASOURCE',
        icon: 'dataSource',
        link: `/home/explore/${workspaceId}`,
        tabId: 'DataSource',
        havingAccess: true,
      },
    ];

    this.subSideBarBookmarkedMenu = [
      {
        title: 'گروه داشبوردی',
        translateKey: 'NavigationSidebar.DASHBOARDGROUP',
        icon: 'dashboardGroup',
        link: `/home/bookmarked/${workspaceId}`,
        tabId: 'DashboardGroup',
        havingAccess: true,
      },
      {
        title: 'داشبورد',
        translateKey: 'NavigationSidebar.DASHBOARD',
        icon: 'dashboard',
        link: `/home/bookmarked/${workspaceId}`,
        tabId: 'Dashboard',
        havingAccess: true,
      },
    ];
  }
}
